export default __webpack_public_path__ + "static/media/3.e796c1f8.jpg";